import {combineReducers} from 'redux'
import coreuiReducer from './coreui'
import authReducer from "./auth"
import toastReducer from "./toaster"
import loaderReducer from "./loader"

export default combineReducers({
    coreuiReducer,
    authReducer,
    toastReducer,
    loaderReducer
})
